import type { PaymentType, TokenizationData } from '#src/app/shared/utils/payments';

import { usePromoteFormState } from '../../../../../formContext';

type Props = {
	token?: string | null;
	accountId?: string | null;
	paymentType: PaymentType;
};

const SAVE_INELIGIBLE_PAYMENT_TYPES = ['applePay', 'googlePay'];

export function useTokenizationData(): (props: Props) => TokenizationData | undefined {
	const [{ paymentMethodSaveOptions }] = usePromoteFormState();

	return function tokenizationData({ token, accountId, paymentType }: Props): TokenizationData | undefined {
		if (!token) return undefined;
		let tokenType: TokenizationData['tokenType'] = paymentMethodSaveOptions.shouldSavePaymentMethod
			? 'permanent'
			: 'temporary';
		if (SAVE_INELIGIBLE_PAYMENT_TYPES.includes(paymentType)) {
			tokenType = 'temporary';
		}
		return {
			token,
			accountId: accountId ?? undefined,
			tokenType,
		};
	};
}
